import dayjs from 'dayjs';
import { TableCell } from './booking-types';
import dayOfYear from 'dayjs/plugin/dayOfYear';
dayjs.extend(dayOfYear);

const outOfSeasonMonthIndexes = [1, 2, 3, 4, 11, 12];

const numberOfDaysInYear = (year: number) => (new Date(year, 1, 29).getDate() === 29 ? 366 : 365);

export const createCalenderYear = (year: number): TableCell[] => {
  const numberOfDays = numberOfDaysInYear(year);
  const tableYearCells: TableCell[] = Array(numberOfDays).fill({ day: ' ', status: 'aa' });

  return tableYearCells;
};
